import img1 from "../../Assets/ftuGuide/projectImages/1.png";
import img2 from "../../Assets/ftuGuide/projectImages/2.png";
import img3 from "../../Assets/ftuGuide/projectImages/3.png";
import img4 from "../../Assets/ftuGuide/projectImages/4.png";
import img5 from "../../Assets/ftuGuide/projectImages/5.png";
import img6 from "../../Assets/ftuGuide/appImages/1.png";
import img7 from "../../Assets/ftuGuide/appImages/2.png";
import img8 from "../../Assets/ftuGuide/appImages/3.png";
import img9 from "../../Assets/ftuGuide/appImages/4.png";

import platformLiteImg from "../../Assets/applifecycle/Platform_lite.png";
import platformProImg from "../../Assets/applifecycle/Platform_Pro.png";
import platformHoloImg from "../../Assets/applifecycle/HOLOBOARD_IMAGE.png";
import platformCardImg from "../../Assets/applifecycle/CARDBOARD_IMAGE.png";

export const FtuSchema = {
  all: [
    {
      imgsrc: img1,
      patchName: "Project Creation",
      title: "Create Project",
      desc: "Create a New Project and Submit your application concept & release plan for concept approval​",
    },
    {
      imgsrc: img2,
      patchName: "Project Creation",
      title: "Upload DEA",
      desc: "Upload the signed DEA to start development and receive a dev kit",
    },
    {
      imgsrc: img3,
      patchName: "Project Creation",
      title: "Start Developing",
      desc: "Start Development and get access to the JioGlass Developers Community for on-demand tech support and guidance on Discord​",
    },
    {
      imgsrc: img4,
      patchName: "Project Creation",
      title: "Submit",
      desc: "Submit your App for Content & Technical QA​​",
    },
    {
      imgsrc: img5,
      patchName: "Project Creation",
      title: "Published",
      desc: "Get Approved and Published on the JioGlass Appstore​",
    },
    {
      imgsrc: img6,
      patchName: "Application Creation",
      title: "Create Application",
      desc: `Create the application by just clicking the above shown button  " Create New App"`,
    },
    {
      imgsrc: img7,
      patchName: "Application Creation",
      title: "Fill Up The Form",
      desc: "Fill the application form with all the details and submit",
    },
    {
      imgsrc: img8,
      patchName: "Application Creation",
      title: "Application Gets Added To Project",
      desc: "Your newly created application will be added to the project",
    },
    {
      imgsrc: img9,
      patchName: "Application Creation",
      title: "Filter Applications By Platform Type",
      desc: "You can filter your applications by platform type by selecting the relevant option",
    },
  ],
  project: [
    {
      imgsrc: img1,
      title: "Create Project",
      desc: "Create a New Project and Submit your application concept & release plan for concept approval​",
    },
    {
      imgsrc: img2,
      title: "Upload DEA",
      desc: "Upload the signed DEA to start development and receive a dev kit",
    },
    {
      imgsrc: img3,
      title: "Start Developing",
      desc: "Start Development and get access to the JioGlass Developers Community for on-demand tech support and guidance on Discord​",
    },
    {
      imgsrc: img4,
      title: "Submit",
      desc: "Submit your App for Content & Technical QA​​",
    },
    {
      imgsrc: img5,
      title: "Published",
      desc: "Get Approved and Published on the JioGlass Appstore​",
    },
  ],
  app: [
    {
      imgsrc: img6,
      title: "Create Application",
      desc: `Create the application by just clicking the above shown button  " Create New App"`,
    },
    {
      imgsrc: img7,
      title: "Fill Up The Form",
      desc: "Fill the application form with all the details and submit",
    },
    {
      imgsrc: img8,
      title: "Application Gets Added To Project",
      desc: "Your newly created application will be added to the project",
    },
    {
      imgsrc: img9,
      title: "Filter Applications By Platform Type",
      desc: "You can filter your applications by platform type by selecting the relevant option",
    },
  ],
};

export const platform = [
  { key: "JioGlass Pro", value: "PRO", color: "#2020B5", icon: platformProImg },
  {
    key: "JioGlass Lite",
    value: "LITE",
    color: "#641895",
    icon: platformLiteImg,
  },
  {
    key: "Jio Prism",
    value: "HOLOBOARD",
    color: "#4ad2ff",
    icon: platformHoloImg,
  },
  {
    key: "Jio Dive",
    value: "CARDBOARD",
    color: "#00c697",
    icon: platformCardImg,
  },
];

export const AppOSPlatform = [
  { key: "Android", value: "android" },
  { key: "IOS", value: "ios" },
];

export const generatedKeys = [
  { key: "Debug Key", value: "debug" },
  { key: "Production Key", value: "production" },
];

export const appStoreProviders = {
  android: {
    id: "google-play-store",
    name: "Google Play Store",
    package: "com.android.vending",
  },
  ios: { id: "apple-app-store", name: "Apple App Store" },
  "android-intent": { id: "android-intent", name: "Launch Android App" },
  "ios-intent": { id: "ios-intent", name: "Launch IOS App" },
};
